import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import queryparse from 'tricks/string/queryparse';
import { useLocation } from 'react-router';
import { getNumberOfPages, getPageFromQuery, locationWithPageNumber } from 'utils/pagination';
import { useFetchMyPlaylistsWithBadge } from 'actions/playlists';
import { PROFILE_ITEMS_PER_PAGE } from 'actions/content';
import Heading from 'components/Heading';
import PageSection from 'components/PageSection';
import Stack from 'components/Stack';
import ItemsGrid from '../ItemsGrid';
import Landmark from 'components/Landmark';
import Box from 'components/Box';
import Pagination from 'components/Pagination';
function Badges(_ref) {
  var badgesAwardedCount = _ref.badgesAwardedCount,
    badgesLockedCount = _ref.badgesLockedCount;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var queryParams = queryparse(location.search);
  var ACHIEVED_BADGES_ID = 'achievedBadges';
  var OUTSTANDING_BADGES_ID = 'outstandingBadges';
  var page = getPageFromQuery({
    query: queryParams
  });
  var _useFetchMyPlaylistsW = useFetchMyPlaylistsWithBadge({
      page: page
    }),
    items = _useFetchMyPlaylistsW.items,
    isError = _useFetchMyPlaylistsW.isError,
    isLoading = _useFetchMyPlaylistsW.isLoading,
    total = _useFetchMyPlaylistsW.total;
  var pageCount = getNumberOfPages({
    total: total,
    itemsPerPage: PROFILE_ITEMS_PER_PAGE
  });
  var unlocked = items === null || items === void 0 ? void 0 : items.filter(function (item) {
    return item.hasUserBadge;
  });
  var remaining = items === null || items === void 0 ? void 0 : items.filter(function (item) {
    return !item.hasUserBadge;
  });
  var showUnlocked = pageCount > 1 ? unlocked && (unlocked === null || unlocked === void 0 ? void 0 : unlocked.length) > 0 : true;
  var showRemaining = pageCount > 1 ? remaining && (remaining === null || remaining === void 0 ? void 0 : remaining.length) > 0 : true;
  return /*#__PURE__*/React.createElement(PageSection, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    mb: "l"
  }, t('badges_title')), /*#__PURE__*/React.createElement(Stack, {
    spacing: "l"
  }, showUnlocked && /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": ACHIEVED_BADGES_ID
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    size: "small",
    mb: "s",
    id: ACHIEVED_BADGES_ID
  }, badgesAwardedCount ? t('badges_unlocked_title', {
    count: badgesAwardedCount
  }) : t('badges_unlocked_title_0')), /*#__PURE__*/React.createElement(ItemsGrid, {
    items: unlocked,
    isError: isError,
    isLoading: isLoading,
    emptyContent: t('unlocked_badges_empty')
  })), showRemaining && /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": OUTSTANDING_BADGES_ID
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    size: "small",
    mb: "s",
    id: OUTSTANDING_BADGES_ID
  }, badgesLockedCount ? t('badges_remaining_title', {
    count: badgesLockedCount
  }) : t('badges_remaining_title_0')), /*#__PURE__*/React.createElement(ItemsGrid, {
    items: remaining,
    isError: isError,
    isLoading: isLoading,
    emptyContent: /*#__PURE__*/React.createElement(Landmark, {
      icon: "like",
      title: t('title_congratulations')
    }, t('remaining_badges_empty'))
  }))), pageCount > 1 && /*#__PURE__*/React.createElement(Box, {
    mt: "m"
  }, /*#__PURE__*/React.createElement(Pagination, {
    pageCount: pageCount,
    currentPage: page,
    getPageLink: function getPageLink(pageNumber) {
      return locationWithPageNumber({
        location: location,
        page: pageNumber
      });
    }
  })));
}
export default Badges;